import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Header } from 'components/Header/Header'
import { firebaseContext } from 'components/MainComponent/FirebasContext'
import { UserInputs } from 'components/UserInputs/UserInputs'
import { ReadDataFromWindow } from 'components/WindowCommunication'
import { child, runTransaction } from 'firebase/database'
import { useContext, useEffect, useState } from 'react'
import { useCustomEvent } from 'react-custom-events-hooks'

const localStorageKey = 'kaffeerechner2026'

function writeLocalStorage(value: string) {
  localStorage && localStorage.setItem(localStorageKey, value)
}
export const Part1 = ({
  tenant,
  colorMode,
}: {
  tenant: Tenant | undefined
  colorMode: 'light' | 'dark' | undefined
}) => {
  const [userHasParticipated, setUserHasParticipated] = useState(false)
  const [userinputs, setUserInputs] = useState<UserInputsType>()
  const [drinksMix, setDrinksmix] = useState<{ [key: string]: number }>()
  const [byCaffeine, setByCaffeine] = useState<{ [key: string]: number }>({})
  const firebaseGlobals = useContext(firebaseContext)
  const [byPortionCount, setByPortionCOunt] = useState<{
    [key: number]: number
  }>()
  function writeUserData(userinputs: UserInputsType) {
    // Skip processing if no valid inputs
    if (!userinputs) return;
  
    // Common filter for drink inputs
    const drinkEntries = Object.entries(userinputs).filter(
      ([key, value]) => !['weight', 'sum', 'caffeine', 'health'].includes(key) && value && value > 0
    );
  
    // 1. Handle drinks mix updates
    if (drinkEntries.length > 0) {
      const userDrinksMixKey = drinkEntries
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([key]) => key.slice(0, 3))
        .join('_');
  
      // Always use child reference to comply with security rules
      runTransaction(
        child(firebaseGlobals.drinksmix, userDrinksMixKey),
        (post) => {
          // For new entries or incrementing existing ones
          return (post || 0) + 1;
        }
      );
    }
  
    // 2. Update drinks count - handle each drink separately
    drinkEntries.forEach(([key, value]) => {
      // Update each drink individually to comply with security rules
      runTransaction(
        child(firebaseGlobals.drinks, key),
        (post) => {
          return (post || 0) + value;
        }
      );
    });
  
    // 3. Update caffeine statistics
    if (userinputs.caffeine !== undefined) {
      const caffeineKey = String(userinputs.caffeine);
      
      // Direct update to child node for caffeine count
      runTransaction(
        child(firebaseGlobals.bycaffeine, caffeineKey),
        (post) => {
          return (post || 0) + 1;
        }
      );
    }
  
    // 4. Update portion count statistics
    if (userinputs.sum !== undefined) {
      const sumKey = String(userinputs.sum);
      
      // Use child reference for portion count to comply with security rules
      runTransaction(
        child(firebaseGlobals.byportioncount, sumKey),
        (post) => {
          // Strictly increment by 1 to comply with ".write": "newData.val() === data.val() + 1 || !data.exists()"
          return (post || 0) + 1;
        }
      );
    }
  }
  const writtenToWindow = useCustomEvent({
    eventName: 'wroteDataToWindow',
  })

  useEffect(() => {
    if (!window.MFDATA) return
    if (!userinputs) return
    window.MFDATA.userinputs = userinputs


    if (!window.MFDATA.userHasParticipated) {

      window.MFDATA.userHasParticipated = true
      writeLocalStorage(JSON.stringify(userinputs))
      writeUserData(userinputs)
    }
    writtenToWindow({})
  }, [userinputs, writtenToWindow])

  function handleNewData(data: dbDataType) {
    if (data?.userinputs?.weight) {
      setUserInputs(data.userinputs)
      setUserHasParticipated(true)
    }
    if (data?.drinksmix) setDrinksmix(data.drinksmix)
    if (data?.bycaffeine) setByCaffeine(data.bycaffeine)
    if (data?.byportioncount) setByPortionCOunt(data.byportioncount)
  }
  return (
    <>
      <ReadDataFromWindow callback={handleNewData} />
        <UserInputs
          currentInputs={userinputs as { [key: string]: number }}
          lang={tenant?.lang}
          colorMode={colorMode || 'light'}
          returnInputs={setUserInputs}
          userHasParticipated={userHasParticipated}
          // changeParticipation={setUserHasParticipated}
        />
    </>
  )
}
